import RequestBase from '../../../api/RequestBase'

export type GoriSignatureResponse =
  | {
      valid: true
      shipment_id: number
      tracking_number: string
      from_street1: string
      from_city: string
      from_state: string
      from_zip: string
      to_street1: string
      to_city: string
      to_state: string
      to_zip: string
      manifest_status: 'Paid' | 'Unpaid'
      from_street2?: string
      to_street2?: string
    }
  | {
      valid: false
      error: string
    }

export function verifyHash(hash: string): Promise<GoriSignatureResponse> {
  return RequestBase.get(`/gori-signature/${hash}`)
}
